// React
import React, { useEffect, useState } from 'react';
// MUI
import { Alert } from '@mui/material';
// State
import { useDispatch } from 'react-redux';
import {
    gatewayCreateState,
    visibleCreateDialog,
} from '../../../app/store/gateway.slice';
import { useAppSelector } from '../../../app/store';
// Formik
import { Dialog } from '../../../components/dialog';
import { CreateGatewayForm } from './forms/create-gateway-form';

const CreateGatewayDialog: React.FC<any> = (props) => {
    const gatewayDialogState = useAppSelector(gatewayCreateState);
    const dispatch = useDispatch();
    const [formKey, setFormKey] = useState(0);

    useEffect(() => {
        if (gatewayDialogState) setFormKey((key) => key + 1);
    }, [gatewayDialogState]);

    const handleClose = () => {
        // if (isLoading) return false;
        dispatch(visibleCreateDialog());
    };

    return (
        <Dialog
            type="success"
            onClose={handleClose}
            open={gatewayDialogState}
            label="ایجاد درگاه پرداخت"
            strictClosing
            icon={<i className="fa-light fa-plus"></i>}>
            <CreateGatewayForm key={formKey} onClose={handleClose} />
        </Dialog>
    );
};

export default CreateGatewayDialog;
